import React from 'react';
import clsx from 'clsx';
import { List } from 'semantic-ui-react';
import formFieldType, { formFieldText } from '@/forms/helper';
import { propertiesWithValue } from '@/utils/resultsHelper';
import FormObjectInputs from '@/forms/objects/components/FormObjectInputs';
import catalogueFieldComponents from '../helper';
import Selectors from '../hooks/selectors';
import Events from '../../catalogue/hooks/events';

const CatalogueObjectInputs = ({
  category,
  code,
  field,
  fields,
  section,
}) => {
  const state = Selectors.useFormFields({ category, code, section });
  const updateProperties = Events.useUpdateDatasetCatalogueProperties(category, { code });

  const onValueChange = (parent, child, value) => {
    const properties = propertiesWithValue(parent, propertiesWithValue(child, value));
    updateProperties({
      properties, fields: [parent.name, child.name], entity: section, template: state.template,
    });
  };

  return (
    <List className={clsx('aridhia-form-object-list', field.code)}>
      <FormObjectInputs
        category={category}
        code={code}
        component={(f) => catalogueFieldComponents[formFieldType(f)]}
        errors={state.saveErrors}
        field={field}
        fields={fields}
        onChange={onValueChange}
        section={section}
        text={(parent, child) => formFieldText(state.dataset, child, 'catalogue.', parent)}
      />
    </List>
  );
};

export default CatalogueObjectInputs;
